<template>
  <div>
    <Header />
    <What />
    <!-- <HowItWorks /> -->
    <section class="hero is-small is-primary">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">Give it a try:</h1>
          <h2 class="subtitle">
            Enter Monthly values below. A visual summary displays below the
            inputs.
            <br />
            The calculator is pre-populated with sample data for illustrative
            purposes. Refresh the page if you want to get back to the starting
            values.
          </h2>
        </div>
        <div class="container has-text-centered">
          <div class="tile is-ancestor">
            <div class="tile is-parent is-6 is-vertical">
              <div class="tile is-child box">
                <Income
                  v-bind:income_items="income_items"
                  v-bind:total_income="total_income"
                  v-on:del-inc="deleteIncome"
                />
                <AddIncome @add-inc="addIncome" />
              </div>
              <div class="tile is-child box">
                <Expenses
                  v-bind:expense_items="expense_items"
                  v-bind:total_expenses="total_expenses"
                  @del-exp="deleteExpense"
                />
                <AddExpense @add-exp="addExpense" />
              </div>
            </div>
            <div class="tile is-parent is-6 is-vertical">
              <div class="tile is-child box">
                <Savings
                  v-bind:savings_items="savings_items"
                  v-bind:total_savings="total_savings"
                  @del-sav="deleteSavings"
                />
                <AddSavings @add-sav="addSavings" />
              </div>
              <div class="tile is-child box">
                <FutureIncome
                  v-bind:future_items="future_items"
                  v-bind:total_future="total_future"
                  @del-fut="deleteFuture"
                />
                <AddFuture v-on:add-fut="addFuture" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="hero is-small is-light">
      <div class="hero-body">
        <h4 class="title is-4">
          Here's what your situation looks like visually . . .
        </h4>
        <Visualize
          v-bind:total_income="total_income"
          v-bind:total_expenses="total_expenses"
          v-bind:total_future="total_future"
          v-bind:total_savings="total_savings"
          v-bind:monthly_net_current="monthly_net_current"
          v-bind:monthly_net_future="monthly_net_future"
          v-bind:future_items="future_items"
          v-bind:expense_items="expense_items"
          v-bind:income_items="income_items"
          v-bind:savings_items="savings_items"
        />
      </div>
      <Summary
        v-bind:monthly_net_current="monthly_net_current"
        v-bind:monthly_net_future="monthly_net_future"
        v-bind:goes_zero="goes_zero"
      />
    </section>
    <div class="container">
      <div class="columns is-full">
        <div class="column"></div>
      </div>
    </div>
    <OptIn />
    <How />
    <Footer />
  </div>
</template>

<script>
import { v4 as uuidv4 } from "uuid";
import Header from "./components/layout/Header.vue";
import What from "./components/content/What.vue";
// import HowItWorks from "./components/content/HowItWorks.vue";
import OptIn from "./components/content/OptIn.vue";
import How from "./components/content/How.vue";
import Income from "./components/income/Income.vue";
import AddIncome from "./components/income/AddIncome.vue";
import Expenses from "./components/expenses/Expenses.vue";
import AddExpense from "./components/expenses/AddExpense.vue";
import Savings from "./components/savings/Savings.vue";
import AddSavings from "./components/savings/AddSavings.vue";
import FutureIncome from "./components/future_income/FutureIncome.vue";
import AddFuture from "./components/future_income/AddFuture.vue";
import Visualize from "./components/visualizations/Visualize.vue";
import Summary from "./components/content/Summary.vue";
import Footer from "./components/layout/Footer.vue";

export default {
  name: "App",
  components: {
    Header,
    What,
    // HowItWorks,
    How,
    OptIn,
    Income,
    AddIncome,
    Expenses,
    AddExpense,
    Savings,
    AddSavings,
    FutureIncome,
    AddFuture,
    Visualize,
    Summary,
    Footer,
  },
  data() {
    return {
      income_items: [
        { id: 1, name: "Salary", amount: 5000 },
        { id: 2, name: "Side Business", amount: 1000 },
      ],
      // total_income: 0,
      expense_items: [
        { id: 1, name: "Housing", amount: 2000 },
        { id: 2, name: "Food", amount: 600 },
        { id: 3, name: "Utilities", amount: 300 },
        { id: 4, name: "Entertainment", amount: 200 },
      ],
      savings_items: [{ id: 1, name: "Cash", amount: 25000 }],
      future_items: [
        { id: 1, name: "Current Sidehustle", amount: 3000, month: 5 },
      ],
    };
  },
  methods: {
    // move add and delete methods down to children components
    addIncome(item) {
      item.id = uuidv4();
      this.income_items.push(item);
    },
    addExpense(item) {
      item.id = uuidv4();
      this.expense_items.push(item);
    },
    addSavings(item) {
      item.id = uuidv4();
      this.savings_items.push(item);
    },
    addFuture(item) {
      this.id = uuidv4();
      this.future_items.push(item);
      if (this.future_items.length > 1) {
        this.future_items.sort((a, b) => {
          return a.month - b.month;
        });
      }
    },
    deleteIncome(id) {
      this.income_items = this.income_items.filter((item) => {
        return item.id !== id;
      });
    },
    deleteExpense(id) {
      this.expense_items = this.expense_items.filter((item) => {
        return item.id !== id;
      });
    },
    deleteSavings(id) {
      this.savings_items = this.savings_items.filter((item) => {
        return item.id !== id;
      });
    },
    deleteFuture(index) {
      this.future_items.splice(index, 1);
    },
  },
  computed: {
    total_income: function () {
      let total = 0;

      this.income_items.forEach((item) => {
        total += parseFloat(item.amount);
      });

      return total;
    },
    total_savings: function () {
      let total = 0;

      this.savings_items.forEach((item) => {
        total += parseFloat(item.amount);
      });

      return total;
    },
    total_expenses: function () {
      let total = 0;
      this.expense_items.forEach((item) => {
        total += parseFloat(item.amount);
      });

      return total;
    },
    total_future: function () {
      let total = 0;
      this.future_items.forEach((item) => {
        total += parseFloat(item.amount);
      });
      return total;
    },
    monthly_net_current: function () {
      let monthly_net_current = this.total_income - this.total_expenses;
      return monthly_net_current;
    },
    monthly_net_future: function () {
      let monthly_net_future =
        this.total_income - this.total_expenses + this.total_future;
      return monthly_net_future;
    },
    goes_zero: function () {
      if (this.monthly_net_current >= 0 && this.monthly_net_future >= 0) {
        return null;
      } else if (this.monthly_net_future == 0) {
        let zm = this.total_savings / this.monthly_net_current;
        return zm;
      } else {
        let running_savings = this.total_savings;
        let zm = 0;
        if (running_savings < 0) {
          zm = 1;
          return zm;
        } else {
          let breakpoint = 0;
          while (running_savings > 0) {
            zm += 1;

            let n_month_future_value = 0;
            this.future_items.forEach((item) => {
              if (zm >= item.month) {
                n_month_future_value += item.amount;
              }
            });
            running_savings += this.monthly_net_current + n_month_future_value;

            breakpoint += 1;
            if (breakpoint > 100) {
              zm = 100;
              break;
            }
          }
          return zm;
        }
      }
    },
  },
};
</script>

<style>
.container {
  margin-top: 20px;
  margin-bottom: 20px;
}
.hero.is-primary .title.is-4 {
  color: #363636;
}

table.center {
  margin-left: auto;
  margin-right: auto;
}
.gots-issues {
  color: hsl(348, 100%, 61%);
}
/* table thead tr {
  background: #cfcfcf;
} */
</style>
